import type { PlaylistItem } from '@/shared/types';

type ItemFingerprint = Pick<PlaylistItem, 'id' | 'video_id' | 'ordem'>;

/** Hash estável da ordem/conteúdo — invalida anti-amnésia após reordenação no admin. */
export function calcularFingerprintPlaylist(itens: readonly ItemFingerprint[]): string {
  return itens.map(item => `${item.ordem}:${item.id}:${item.video_id}`).join('|');
}

/** Preserva a faixa atual após reordenação (match por video_id). */
export function remapearIndicePorVideo(
  anterior: readonly ItemFingerprint[],
  data: readonly ItemFingerprint[],
  indexAtual: number,
): number {
  if (data.length === 0) return 0;
  const videoId = anterior[indexAtual]?.video_id;
  if (!videoId) return Math.min(indexAtual, data.length - 1);
  const novo = data.findIndex(i => i.video_id === videoId);
  return novo >= 0 ? novo : 0;
}
